import { render, staticRenderFns } from "./TeamMatchResult.vue?vue&type=template&id=593e1c5e&scoped=true"
import script from "./TeamMatchResult.vue?vue&type=script&lang=js"
export * from "./TeamMatchResult.vue?vue&type=script&lang=js"
import style0 from "./TeamMatchResult.vue?vue&type=style&index=0&id=593e1c5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593e1c5e",
  null
  
)

export default component.exports